<template>
    <transition name="cz3__fade">
        <div
            v-if="shouldShowPanelResetButton"
            class="h-auto underline normal-case tracking-normal"
        >
            <button
                @click="setShouldShowResetModal(true)"
                :is-disabled="isDisabled"
                class="h-auto underline normal-case text-[16px] tracking-snug"
            >
                {{ $t('RESET') }}
            </button>

            <teleport to="#cz3" v-if="shouldShowResetModal">
                <base-modal-confirm
                    @modalClose="setShouldShowResetModal(false)"
                    @confirmAndExit="resetPanelAndClose"
                    :show-modal="shouldShowResetModal"
                    :modal-heading="$t('RESET_YOUR_SELECTIONS')"
                    :cta-copy="$t('RESET')"
                />
            </teleport>
        </div>
    </transition>
</template>

<script>
    import { Teleport } from 'vue';
    import allStores from '../../stores/all';

    import BaseModalConfirm from '../BaseModalConfirm.vue';

    export default {
        mixins: [allStores],

        components: {
            BaseModalConfirm,
            Teleport,
        },

        data() {
            return {
                isDisabled: false,
            };
        },

        computed: {
            currentGroup() {
                return this.customizerStore.currentGroup;
            },

            paintfillPlacementCode() {
                const paintfill = this.visibleGroups.find((group) => group.name === 'Paintfill');
                const selected = this.viewController.selectedAtPlacement(paintfill.code);

                return selected.code;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            isComplete() {
                if (this.currentGroup === 'Face/Sole') {
                    return this.customizerStore.selectionsMade?.includes('Face/Sole');
                }
                return this.customizerStore.selectionsMade?.includes(this.currentGroup);
            },

            shouldShowPanelResetButton() {
                switch (this.currentGroup) {
                case 'Face/Sole': {
                    // If No Customization explicitly selected for Front, show the reset button
                    if (this.customizerStore.isFrontNoCustomizationSelected('Face/Sole')) {
                        return true;
                    }

                    // Determine Front completeness inline to avoid relying on selectionsMade grouping
                    const initials = this.viewController?.selectedAtPlacement('StampingStyle');
                    const stamps = this.viewController?.selectedAtPlacement('Stamp');
                    const hasStamps = !!(stamps && !stamps.placeholder && stamps.code !== 'Stamp-Stamp-Blank');
                    const hasPaintfill = this.customizerStore
                        .paintfillColorPlacementCodesForGroup('Face/Sole')
                        .some((placementCode) => (
                            this.customizerStore.isColorPlacementSelected(placementCode)
                        ));

                    if (hasPaintfill) {
                        return true;
                    }

                    // Initials are only valid if selected AND required text fields are satisfied AND no profanity errors
                    const initialsSelected = !!(initials && !initials.placeholder);
                    let hasInitials = false;
                    if (initialsSelected) {
                        const requiresText1 = initials?.custom?.['v-stamping-has-text-1'] === 'yes';
                        const text1Value = initials?.custom?.['v-stamping-text-1'];
                        const requiresText2 = initials?.custom?.['v-stamping-has-text-2'] === 'yes';
                        const text2Value = initials?.custom?.['v-stamping-text-2'];

                        const text1Ok = !requiresText1 || (text1Value != null && `${text1Value}`.length > 0);
                        const text2Ok = !requiresText2 || (text2Value != null && `${text2Value}`.length > 0);

                        const panelErrors = this.customizerStore.panelsInErrorState ?? [];
                        const group = this.customizerStore.currentGroup;
                        const hasProfanityError = panelErrors.includes(`${group}-v-stamping-text-1`) || panelErrors.includes(`${group}-v-stamping-text-2`);

                        hasInitials = text1Ok && text2Ok && !hasProfanityError;
                    }

                    // Otherwise, show if initials or stamps are validly selected
                    return hasStamps || hasInitials;
                }
                case 'Grip':
                case 'Shaft':
                case 'Character Stamping':
                case 'Specifications':
                default:
                    return this.isComplete;
                }
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            shouldShowResetModal() {
                return this.appStore.shouldShowResetModal;
            },
        },

        methods: {
            setShouldShowResetModal(value) {
                this.appStore.setShouldShowResetModal(value);
            },

            resetPanelAndClose() {
                this.customizerStore?.resetCurrentPanel();

                this.setShouldShowResetModal(false);
            },
        },
    };
</script>
